import { Grid, Typography } from '@mui/material';
import React from 'react';
import { DrawerBoxComponent } from '../DrawerBoxComponent/DrawerBoxComponent';
import AvatarImg from '../Layout/AvatarImg';

export const AppointmentProviderInfo = ({
  providerName,
  providerDetails,
  avatarSrc,
}) => {
  return (
    <DrawerBoxComponent>
      <Grid container>
        <Grid item>
          <AvatarImg sx={{ mt: 0 }} userName={providerName} src={avatarSrc} />
        </Grid>
        <Grid item>
          <Grid container direction="column">
            <Grid item>
              <Typography variant="navSelected">{providerName}</Typography>
            </Grid>
            <Grid item>
              <Typography variant="columnName">{providerDetails}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </DrawerBoxComponent>
  );
};
